exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#mobile-loader-spinner{animation:spin 1.25s infinite linear;box-sizing:border-box;display:block;border:8px solid #c8c8c8;border-radius:100%;border-top-color:#184e78;margin:50% auto 0;height:96px;width:96px}.loader-text{text-align:center}@keyframes spin{to{transform:rotate(1turn)}}.splash-screen{z-index:100}.splash-screen .top-section{width:536px;margin-left:calc(50vw - 268px);text-align:center;margin-top:200px}.splash-screen .top-section p{font-family:Open Sans,sans-serif;font-weight:400;text-transform:uppercase}.splash-screen .top-section .ao-logo{margin:10vh auto}.splash-screen hr{border-width:1px;border-color:red;width:100%}.splash-screen .bottom-section{margin-top:15px;text-align:center;position:fixed;bottom:0;width:100%}.splash-screen .bottom-section p{font-family:Open Sans,sans-serif;font-weight:400;font-size:9px;color:#000;letter-spacing:1px}.splash-screen.transparent{position:absolute;left:0;top:0;width:100%;height:100%;z-index:100}.splash-screen.transparent,.splash-screen.transparent .top-section{background-color:transparent}.splash-screen.transparent .top-section .ao-logo,.splash-screen.transparent .top-section p{display:none}.splash-screen.transparent .top-section .loader{margin:auto}.splash-screen.transparent .bottom_section,.splash-screen.transparent hr{display:none}.splash-screen.pdf{position:absolute;left:0;top:0;width:90vw;height:100vh;z-index:100;background-color:#c7c4c4;opacity:.8}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/MobileSpinner/MobileSpinner.scss
// module id = 1584
// module chunks = 0